function initCountdown(wrapper) {
  var endTimeStr = wrapper.dataset.endTime;
  if (!endTimeStr) return;

  var endTime = new Date(endTimeStr).getTime();
  var id = wrapper.id.replace('countdown-', '');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function update() {
    var diff = endTime - Date.now();
    if (diff <= 0) {
      wrapper.style.display = 'none';
      return;
    }
    document.getElementById('cd-days-'  + id).textContent = pad(Math.floor(diff / 86400000));
    document.getElementById('cd-hours-' + id).textContent = pad(Math.floor((diff % 86400000) / 3600000));
    document.getElementById('cd-mins-'  + id).textContent = pad(Math.floor((diff % 3600000) / 60000));
    document.getElementById('cd-secs-'  + id).textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  update();
  setInterval(update, 1000);
}

document.querySelectorAll('[id^="countdown-"][data-end-time]').forEach(initCountdown);
